import type { HeroId, Slot } from "@rivalwatch/shared";
import { CLIENT_HEROES } from "../../heroes/index.ts";
import type { Cue } from "../engine.ts";
import { genericReload, melee, dryFire, whiz, ricochet, hookHit, snareArmed, missileLaunch, pickup, revive, lullaby, surged, wardUp, wardDown, wardBreak, sprintStart, portalOpen, orbBounce, impact, explosion, scope } from "../../heroes/audio-cues.ts";

export interface FireCtx {
  alt?: boolean;
  ult?: boolean;
  scoped?: boolean;
}

export const fire = (hero: HeroId, v: FireCtx = {}) => CLIENT_HEROES[hero].audio.fire(v).cue;
export const reload = (hero: HeroId, seconds: number): Cue => CLIENT_HEROES[hero].audio.reload?.(seconds) ?? genericReload(seconds);
export const ability = (hero: HeroId, slot: Slot): Cue | undefined => CLIENT_HEROES[hero].audio.ability?.[slot];

export { melee, dryFire, whiz, ricochet, hookHit, snareArmed, missileLaunch, pickup, revive, lullaby, surged, wardUp, wardDown, wardBreak, sprintStart, portalOpen, orbBounce, impact, explosion, scope };
